
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    isLoadingGetLogsModulesWithOperation: false,

    logModulesList: [],

    logOperationList: [],
    

}


export const getLogsModulesWithOperation = createAsyncThunk("log/getLogsModulesWithOperation", async(_, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/Logging/ModulesWithOperation`)
        
        return data
    } catch (error) {
        console.log(error);
        return thunkApi.rejectWithValue(error)
    }
})

export const getLogsByCompanyIdQuery = createAsyncThunk("log/getLogsByCompanyIdQuery", async(_, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/Logging/GetLogsByCompanyId`)

        
        return data
    } catch (error) {
        console.log(error);
        return thunkApi.rejectWithValue(error)
    }
})


const logSlice = createSlice({
    name: "log",
    initialState,
    reducers: {

        setLogOperationList: (state, action) => {
            state.logOperationList = action.payload
        }

    },
    extraReducers:(builder)=> {
        builder

        //! getLogsModulesWithOperation
        .addCase(getLogsModulesWithOperation.pending, (state)=> {
            state.isLoadingGetLogsModulesWithOperation = true
        })

        .addCase(getLogsModulesWithOperation.fulfilled, (state, action)=> {
            state.isLoadingGetLogsModulesWithOperation = false
            state.logModulesList = action.payload.data.$values
            
        })

        .addCase(getLogsModulesWithOperation.rejected, (state, action)=> {
            state.isLoadingGetLogsModulesWithOperation = false
        })
    }
})


export const {
    setLogOperationList
} = logSlice.actions
export default logSlice.reducer